import {
  CategoriesActionTypes,
  LOAD_CATEGORIES_SUCCESS,
  SBCategory,
} from "./categories.types";

const initialState: SBCategory[] = [];

export const reducer = (
  state = initialState,
  action: CategoriesActionTypes
): SBCategory[] => {
  switch (action.type) {
    case LOAD_CATEGORIES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};
